/** Display formatting for evidence values. No rounding that would misstate an amount. */

export function shortHex(value: string, headLength = 10, tailLength = 8): string {
  if (value.length <= headLength + tailLength + 3) return value;
  return `${value.slice(0, headLength)}…${value.slice(-tailLength)}`;
}

export function shortCommit(sha: string): string {
  return sha.slice(0, 10);
}

/** Renders a base-10 wei string as ETH with up to 6 fractional digits, keeping the exact wei value visible via `title`. */
export function formatWei(wei: string): string {
  try {
    const value = BigInt(wei);
    const whole = value / 1_000_000_000_000_000_000n;
    const fraction = value % 1_000_000_000_000_000_000n;
    const fractionStr = fraction.toString().padStart(18, "0").slice(0, 6).replace(/0+$/, "");
    return fractionStr.length > 0 ? `${whole}.${fractionStr} ETH` : `${whole} ETH`;
  } catch {
    return `${wei} wei`;
  }
}

export function formatGateStatus(status: string): string {
  return status.charAt(0).toUpperCase() + status.slice(1);
}

export function formatRelation(relation: string): string {
  switch (relation) {
    case "match":
      return "Matched";
    case "insert":
      return "Inserted";
    case "delete":
      return "Removed";
    case "replace":
      return "Replaced";
    case "ambiguous":
      return "Ambiguous";
    default:
      return relation;
  }
}
